import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import ArticlePage from '@/pages/ArticlePage';
import ProfilePage from '@/pages/ProfilePage';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import CookiePolicy from '@/pages/CookiePolicy';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AuthModal from '@/components/AuthModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    // Apply theme to document
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  useEffect(() => {
    if (token) {
      // Verify token and get user
      axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        setUser(response.data);
      })
      .catch(() => {
        // Invalid token
        localStorage.removeItem('token');
        setToken(null);
      });
    }
  }, [token]);

  const login = (newToken, newUser) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUser(newUser);
    setShowAuthModal(false);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  const openAuthModal = (mode = 'login') => {
    setAuthMode(mode);
    setShowAuthModal(true);
  };

  return (
    <div className="App min-h-screen bg-background text-foreground flex flex-col">
      <BrowserRouter>
        <Navbar 
          user={user} 
          logout={logout} 
          openAuthModal={openAuthModal}
          theme={theme}
          toggleTheme={toggleTheme}
          token={token}
        />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage user={user} token={token} openAuthModal={openAuthModal} />} />
            <Route path="/article/:id" element={<ArticlePage user={user} token={token} openAuthModal={openAuthModal} />} />
            <Route path="/profile" element={<ProfilePage user={user} token={token} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </div>
        <Footer />
        {showAuthModal && (
          <AuthModal 
            mode={authMode}
            setMode={setAuthMode}
            onClose={() => setShowAuthModal(false)}
            onSuccess={login}
          />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;